import React from 'react';
import { WebSocketHook } from 'react-use-websocket/dist/lib/types';

export interface IWS extends WebSocketHook<MessageEvent<any>>{
}

// @ts-ignore
export default React.createContext<IWS>();